/*
 * @FilePath: /kitchen-online-web/src/3DEngine/render/renderTypes/renderIType.js
 * @Author: Yongchao Wang
 * @Date: 2021-07-20 11:21:10
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-22 09:39:31
 */
import { Vector3, Vector2 } from '@babylonjs/core/Maths/math';
import MeshManage from '../meshManage';
import SkirtingBoard from '../specialHandler/skirtingBoard';
import TopPanel from '../specialHandler/topPanel';
import { calloutLineFilter, getTopCabinetLengthInfo } from '../utils/lengthUtils';
import {
  FRAMEDEPTH,
  MINIMUM_WALL_WIDTH,
  MINIMU_CAMERA_DISTANCE,
  SKIRTINGBOARDCONFIG,
  TOPFRAME_GROUND,
  TOPPANELCONFIG,
  GAP_BETWEEN_WALL_AND_CABINET,
} from '../utils/kitchenConfig';
import {
  checkFrameIsHighFrame, checkPreFrameIsHighFrame,
  // putTopHightFrame,
  // checkouHasHightFrame,
  // renderSealPlatePos,
  checkHasHightFrameByPosition,
} from '../utils/renderUtils';
import RenderBaseType from './renderBaseType';

import {
  BASICLENGTHTYPE_ENUM, CALLOUTLINE_TITLE,
  BASICTYPE_ENUM, SidePlatePosition, SidePlateSequence, LengthType, AXES_ENUM, LengthLocation,
  CALLOUTLINE_TYPE,
} from '../utils/enum';
import { getFramePositionInfo, getIsHighSinkCabinet } from '../utils/templatejsonUtils';
import LengthX from '../lengthTypes/lengthX';
import Ground from '../room/ground';
import LengthZ from '../lengthTypes/lengthZ';
import LengthP2Z from '../lengthTypes/lengthP2Z';
import LengthP2X from '../lengthTypes/lengthP2X';
import HightFrame from '../specialHandler/highFrame';
import renderNoFrame from '../specialHandler/renderNoFrame';
import getTopPanelInfo from '../heightSinkCabinet/renderISinkCabinet';
import { renderIP2XTop, renderIZTop } from '../topCabinetSideChange/renderITop';

class RenderIType extends RenderBaseType {
  /**
   * @description: 渲染I型顶柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderTop() {
    // I型返回的是一个字符串  为length1||length2||length3
    const { length } = getTopCabinetLengthInfo(this.templateJson?.top);
    if (!length) return;
    switch (length) {
      case LengthType.Length1:
        this.topLength1 = new LengthX(this.templateJson, this.scene, LengthLocation.Top,
          LengthType.Length1, this.copyTemplateJson);
        this.putTopCupboard();
        break;
      case LengthType.Length2:
        this.topLength2 = new LengthZ(this.templateJson, this.scene, LengthLocation.Top,
          LengthType.Length2, this.copyTemplateJson);
        renderIZTop(this);
        break;
      default:
        this.topLength3 = new LengthP2X(this.templateJson, this.scene, LengthLocation.Top,
          LengthType.Length3, this.copyTemplateJson);
        renderIP2XTop(this);
        break;
    }

    if (this?.templateJson?.version > '2.2') {
      this.renderSidePlatesByType(SidePlatePosition.Top);
    } else {
      this.renderSidePlates(SidePlatePosition.Top);
    }
  }

  /**
   * @description: 渲染I型底柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderBottom() {
    if (!this?.templateJson?.bottom?.length1?.frames) {
      return;
    }
    this.bottomLength1 = new LengthX(this.templateJson, this.scene, 'bottom', 'length1', this.copyTemplateJson);
    this.putBottomCupboard();
    // 渲染补板
    // this.handleSealPlate(BASICTYPE_ENUM.bottom);
    // version2.0 remove by zhanyu.shen 20211228, 单独渲染踢脚板，顶柜有高柜影响踢脚板 see renderEngine/index
    // this.renderSkirtingBoard();
    this.renderTopPanel();
    if (this?.templateJson?.version > '2.2') {
      this.renderSidePlatesByType(SidePlatePosition.Bottom);
    } else {
      this.renderSidePlates(SidePlatePosition.Bottom);
    }
  }

  renderWindow() {
    const { frame, window } = this.getWindowFrame('bottom', 'length1');
    this.bottomLength1.createWindow(frame, window);
    this.addMesh(this.bottomLength1?.windowNode?.windowMesh);
    // 如果窗户隐藏自动隐藏窗户
    if (!this.windowVisiable) {
      this.showWindow(this.windowVisiable);
    }
  }


  renderRoom() {
    // 没有墙地面信息不渲染
    if (!this.templateJson?.other) {
      return;
    }
    // 需要一个最小墙，使房间看起来大一些
    const l2Width = MINIMUM_WALL_WIDTH;
    const l1Width = this.bottomLength1.getSideLength();
    this.groundNode = new Ground(this.scene, this.engine, { width: l1Width, height: l2Width });
    this.bottomLength1.createWall();
    this.bottomLength2 = new LengthZ(this.templateJson, this.scene, 'bottom', 'length2', this.copyTemplateJson);
    this.bottomLength2.createWall(l2Width);
    this.bottomLength3 = new LengthP2X(this.templateJson, this.scene, 'bottom', 'length3', this.copyTemplateJson);
    this.bottomLength3.createWall(l1Width, l2Width);
    this.bottomLength4 = new LengthP2Z(this.templateJson, this.scene, 'bottom', 'length4', this.copyTemplateJson);
    this.bottomLength4.createWall(l2Width, l1Width);
    const wallInfo = this.templateJson?.other?.wall;
    this.changeWallColor(wallInfo.baseModelUrl,
      wallInfo.normalModelUrl, { width: wallInfo.width * 0.001, height: wallInfo.height * 0.001 });

    const grounds = [
      new Vector2(0, -GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(-l1Width, -GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(-l1Width, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(0, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
    ];
    this.groundNode.createGround(grounds, new Vector3(0, 0, 0));
    this.groundNode.changeMaterial(this.templateJson.other.floor.baseModelUrl,
      this.templateJson.other.floor.normalModelUrl,
      { width: this.templateJson.other.floor.width * 0.001, height: this.templateJson.other.floor.height * 0.001 });
    this.roomMeshes = [
      this?.groundNode?.groundMesh,
      this.bottomLength1?.wallNode?.wallMesh,
      this.bottomLength2?.wallNode?.wallMesh,
      this.bottomLength3?.wallNode?.wallMesh,
      this.bottomLength4?.wallNode?.wallMesh,
    ];
    this.renderWindow();
  }

  renderSidePlates(position) {
    // I型柜 只需渲染Length1
    const iTypeLength1 = this.templateJson[position].length1;
    // Length1上的侧板数组
    const sidePlatesArray = iTypeLength1.sidePlates;

    if (sidePlatesArray) {
    // First侧板的基准Mesh
      const firstFrameJson = iTypeLength1.frames[0];
      // Last侧板的基准Mesh
      const lastFrameJson = iTypeLength1.frames[iTypeLength1.frames.length - 1];

      const l1 = new LengthX(this.templateJson, this.scene);

      // 根据基准Mesh来渲染First或Last侧板
      const l1FirstSidePlateRotationData = l1.renderSidePlate(firstFrameJson,
        sidePlatesArray, SidePlateSequence.First, position);
      if (sidePlatesArray.length === 2) {
        const l1LastSidePlateRotationData = l1.renderSidePlate(lastFrameJson,
          sidePlatesArray, SidePlateSequence.Last, position);
        this.addRotationMeshes(l1LastSidePlateRotationData);
      }

      // 添加所有使用到的侧板到allMeshes数组
      this.addSidePlatesMeshes(sidePlatesArray);
      // 保存每个侧板的旋转角度(更换侧板后需要恢复角度)
      this.addRotationMeshes(l1FirstSidePlateRotationData);
    }
  }

  renderSidePlatesByType(position) {
    // I型柜所在的边
    const length = position === 'top'
      ? `Length${getTopCabinetLengthInfo(this.templateJson[position]).length.slice(-1)}` : 'Length1';
    const lengthType = position === 'top'
      ? getTopCabinetLengthInfo(this.templateJson[position]).length : 'length1';
    // I型只有x边（老版本） 顶柜换边之后l1l2l3都可以放I型柜
    const lTypeLength = this.templateJson[position][lengthType];
    // ver2.3及以上版本的侧板数组
    const lengthSidePlatesArr = lTypeLength.sidePlatesV2;
    // 根据边 渲染侧板
    console.log(`${position}${length}`);
    this[`${position}${length}`].renderSidePlateByLength(lengthSidePlatesArr, position);
    // 如果有冰箱且冰箱的需要渲染   有冰箱的话必定是version2.3以上的 所以不需要考虑低版本的上面一个方法
    if (this.refrigeraror?.type === position) {
      this[`${position}${length}`].setRefrigerator(this.refrigeraror, position);
    }
  }


  setCalloutLine() {
    if (this.templateJson.bottom.type === 'I') {
      this.setBottomCalloutLine();
    }

    // version2.0 无顶柜的时候top为null
    if (this.templateJson.top?.type === 'I') {
      this.setTopCalloutLine();
    }
  }

  setBottomCalloutLine() {
    const { Length, EndHeight, EndDepth } = CALLOUTLINE_TYPE;
    const showList = [Length, EndHeight, EndDepth];
    const isHighAndLow = this.templateJson.bottom.highAndLow;
    const calloutLineLength1 = this.bottomLength1?.getFramesCalloutLine(LengthLocation.Bottom);
    this.calloutLineInfo.bottom = {
      length1: isHighAndLow
        ? calloutLineLength1 : calloutLineFilter(showList, calloutLineLength1),
    };
  }

  setTopCalloutLine() {
    const { L1 } = CALLOUTLINE_TITLE;
    const { Length, EndHeight, EndDepth } = CALLOUTLINE_TYPE;
    const showList = [Length, EndHeight, EndDepth];
    const calloutLineLength1 = this.topLength1?.getFramesCalloutLine(LengthLocation.Top, L1);
    const calloutLineLength2 = this.topLength2?.getFramesCalloutLine(LengthLocation.Top, L1);
    const calloutLineLength3 = this.topLength3?.getFramesCalloutLine(LengthLocation.Top, L1);
    const { length } = getTopCabinetLengthInfo(this.templateJson?.top);
    switch (length) {
      case LengthType.Length1:
        this.calloutLineInfo.top = { length1: calloutLineFilter(showList, calloutLineLength1) };
        break;
      case LengthType.Length2:
        this.calloutLineInfo.top = { length2: calloutLineFilter(showList, calloutLineLength2) };
        break;
      case LengthType.Length3:
        this.calloutLineInfo.top = { length3: calloutLineFilter(showList, calloutLineLength3) };
        break;
      default:
        break;
    }
  }

  /**
   * @description: 渲染台面
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderTopPanel() {
    const topPanelTexture = this?.templateJson?.bottom?.topPanels[0].componentBasic?.modelUrl;

    const lastFrame = this.templateJson.bottom.length1?.frames[this.templateJson.bottom.length1.frames.length - 1];
    const mesh = this.scene.getMeshByName(lastFrame.componentBasic.id);
    if (!mesh) {
      return;
    }
    const lastMeshManage = new MeshManage(mesh);

    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    let sidePlateDepth = this.getSidePlateDepth('length1');

    // version 2.0 add by zhanyu.shen 20211227 begin, 当顶柜有高柜，底柜和高柜需要补板填补空隙(比如底柜240顶柜307)
    let sealPlateSizeX = 0;
    if (this.isSealPlateBeforeTopHightFrame(LengthType.Length1)
    || this.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
      sealPlateSizeX = this.getSealPlateSize(LengthLocation.Bottom, LengthType.Length1, AXES_ENUM.x);
    }
    // add by zhanyu.shen 20211227 end
    // 检查顶柜里是否有高柜
    if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
      if (!this.checkTopHightFrameIsSeparated(LengthType.Length1)) {
        // 当顶柜有高柜，底柜和高柜之间相连，高柜侧板与底柜最后一个柜子重叠在一起，此时台面需要减去侧板厚度
        sidePlateDepth = -sidePlateDepth;
      }
    }

    const lengthXCenterPoint = lastMeshManage.getLengthXConfigs(sealPlateSizeX + sidePlateDepth).centerPoint;
    const lengthXLength = lastMeshManage.getLengthXConfigs(sidePlateDepth + sealPlateSizeX).length;


    const topPanelInfoArr = getTopPanelInfo(this, lengthXLength);
    const position = {
      // version 2.0 modify by zhanyu.shen 20211227, 补板X轴尺寸计入台面X坐标
      // x: bounds.min.x / 2,
      x: lengthXCenterPoint,
      y: this.templateJson.bottom.height * 0.01 + SKIRTINGBOARDCONFIG.HEIGHT + TOPPANELCONFIG.HEIGHT / 2,
      z: FRAMEDEPTH.BOTTOM / 2 + TOPPANELCONFIG.DEPTH / 2,
    };
    const size = {
      // version 2.0 modify by zhanyu.shen 20211227, 补板X轴尺寸计入台面width尺寸
      // width: Math.abs(bounds.min.x) + sidePlateDepth * 2,
      width: lengthXLength,
      height: TOPPANELCONFIG.HEIGHT,
      depth: FRAMEDEPTH.BOTTOM + TOPPANELCONFIG.DEPTH,
    };

    const topPanelArr = [];
    if (getIsHighSinkCabinet(this.templateJson)) {
      topPanelInfoArr.forEach((item) => {
        const tempTopPanel = new TopPanel(this.scene, item.position, item.size, true);
        tempTopPanel.createTopPanel(topPanelTexture);
        topPanelArr.push(tempTopPanel);
      });
    } else {
      const tempTopPanel = new TopPanel(this.scene, position, size, true);
      tempTopPanel.createTopPanel(topPanelTexture);
      topPanelArr.push(tempTopPanel);
    }

    const lastTopPanel = topPanelArr[topPanelArr.length - 1];
    const sinkPositionInfo = { ...getFramePositionInfo(this?.templateJson, 'sink') };
    // 如果水槽存在且水槽在1
    if (sinkPositionInfo.id && sinkPositionInfo.location === 1) {
      const lx = new LengthX(this.templateJson, this.scene);
      // eslint-disable-next-line max-len
      const { holePosition, holeSize } = lx.getSinkHolePosition(sinkPositionInfo.cabinetId, sinkPositionInfo.id, lastTopPanel.position.y, null, sinkPositionInfo.frameInfo);
      lx.createHole(holePosition, holeSize, topPanelTexture,
        lastTopPanel, sinkPositionInfo.frameInfo.componentBasic.componentId);
    }

    // 如果有高柜，高柜位置挖洞
    if (this.highFrameMesh && this.highFrameMeshLocation === 1) {
      // version 2.0 modify by zhanyu.shen 20220104 begin 将多个高柜作为一个整体获取中心坐标和尺寸
      const highFrameData = this.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.bottom, LengthType.Length1);// new code
      const holePosition = {
        // x: highFrameData?.position?.x - sidePlateDepth / 2,
        x: this.templateJson.version > '2.2'
          ? highFrameData?.position?.x : highFrameData?.position?.x - sidePlateDepth / 2,
        y: lastTopPanel.position.y,
        z: lastTopPanel.position.z,
      };
      // const highSize = new MeshManage(this.highFrameMesh).getModelSize();
      const holeSize = {
        // width: highFrameData?.size?.x + sidePlateDepth,
        width: this.templateJson.version > '2.2'
          ? highFrameData?.size?.x + sidePlateDepth * 2 : highFrameData?.size?.x + sidePlateDepth,
        height: TOPPANELCONFIG.HEIGHT,
        depth: size.depth,
      };
      // modify by zhanyu.shen 20220104 end
      lastTopPanel.createHoleTopPanel(holePosition, holeSize, topPanelTexture);
    }
    topPanelArr.forEach((item) => {
      this.topPanelMesh.push(item.mesh);
      this.topPanelObjs.push(item);
    });
  }


  /**
   * @description:渲染踢脚板
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderSkirtingBoard() {
    const skirtingBoardTexture = this?.templateJson?.bottom?.coverPlate?.componentBasic?.modelUrl;

    const lastFrame = this.templateJson.bottom.length1?.frames[this.templateJson.bottom.length1.frames.length - 1];
    // const lastFrameDoor = lastFrame.doors[0];
    const mesh = this.scene.getMeshByName(lastFrame.componentBasic.id);
    if (!mesh) {
      return;
    }
    const doorDepth = 0;
    // version 2.0 add by zhanyu.shen 20211228 begin
    let highFrameData = null;
    let highFrameFrontSideLength = 0; // 顶柜组里高柜的正面边长
    let sealPlateSizeX = 0; // 底柜和高柜间填补空隙的补板长
    let highFrameSkirtingBoard = [];
    // 检查顶柜里是否有高柜
    if (checkHasHightFrameByPosition(this.templateJson, BASICTYPE_ENUM.top, LengthType.Length1)) {
      highFrameData = this.getHighFrameGroupPositionAndSize(BASICTYPE_ENUM.top, LengthType.Length1);
      highFrameFrontSideLength = highFrameData?.size?.x;
      if (this.isSealPlateBeforeTopHightFrame(LengthType.Length1, true)) {
        // 当顶柜有高柜，底柜和高柜之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
        sealPlateSizeX = this.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
      } else if (this.checkTopHightFrameIsSeparated(LengthType.Length1)) {
        // I型Length1边至少有两个柜体，不分离的情况下如果有补板只会放在第一个柜子后面sealPlateSizeX不需要作为延伸尺寸，比如底柜160顶柜220
        // 底柜和顶柜高柜分离
        // 这里处理：底柜和高柜之间不需要补板填补空隙，此时空隙较大，高柜左前右需要新建三块踢脚板
        highFrameSkirtingBoard = this.renderTopHighFrameSkirtingBoardLength1(highFrameData, skirtingBoardTexture);
        highFrameFrontSideLength = 0; // 原先的踢脚板长度不需要延伸
      }
    }
    if (sealPlateSizeX === 0 && this.isSealPlateBeforeTopRefrigeraror(LengthType.Length1)) {
      // 当顶柜没有高柜但有冰箱，底柜和冰箱之间需要补板填补空隙(比如底柜240顶柜307)，正面踢脚板长度延伸，右面位置移动到高柜右边
      sealPlateSizeX = this.getSealPlateSize(BASICTYPE_ENUM.bottom, LengthType.Length1, AXES_ENUM.x);
    }
    // add by zhanyu.shen 20211227 end

    const bounds = mesh.getHierarchyBoundingVectors();

    // const door = this.scene.getMeshByName(lastFrameDoor.componentBasic.id).getHierarchyBoundingVectors();
    // 正面的踢脚板
    const position1 = {
      // version 2.0 modify by zhanyu.shen 20211228, 将高柜正面宽和补板宽计入正面的踢脚板X坐标
      // x: bounds.min.x / 2,
      x: bounds.min.x / 2 - highFrameFrontSideLength / 2 - sealPlateSizeX / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: FRAMEDEPTH.BOTTOM - SKIRTINGBOARDCONFIG.DEPTH / 2 - doorDepth,
    };
    const size1 = {
      // version 2.0 modify by zhanyu.shen 20211228, 将高柜正面宽和补板宽计入正面的踢脚板width
      // width: Math.abs(bounds.min.x),
      width: Math.abs(bounds.min.x) + highFrameFrontSideLength + sealPlateSizeX,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: SKIRTINGBOARDCONFIG.DEPTH,
    };
    const skirtingBoard1 = new SkirtingBoard(this.scene, position1, size1);

    skirtingBoard1.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(skirtingBoard1);

    // 右面的踢脚板
    const position2 = {
      // version 2.0 modify by zhanyu.shen 20211228, 将高柜正面宽和补板宽计入右面的踢脚板X坐标，只需移动位置尺寸不变
      // x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2,
      x: bounds.min.x - SKIRTINGBOARDCONFIG.DEPTH / 2 - highFrameFrontSideLength - sealPlateSizeX,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: FRAMEDEPTH.BOTTOM / 2,
    };
    const size2 = {
      width: SKIRTINGBOARDCONFIG.DEPTH,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: FRAMEDEPTH.BOTTOM - doorDepth,
    };
    const skirtingBoard2 = new SkirtingBoard(this.scene, position2, size2);

    skirtingBoard2.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(skirtingBoard2);

    // 左面的踢脚板
    const position3 = {
      x: SKIRTINGBOARDCONFIG.DEPTH / 2,
      y: SKIRTINGBOARDCONFIG.HEIGHT / 2,
      z: FRAMEDEPTH.BOTTOM / 2,
    };
    const size3 = {
      width: SKIRTINGBOARDCONFIG.DEPTH,
      height: SKIRTINGBOARDCONFIG.HEIGHT,
      depth: FRAMEDEPTH.BOTTOM - doorDepth,
    };
    const skirtingBoard3 = new SkirtingBoard(this.scene, position3, size3);

    skirtingBoard3.createSkirtingBoard(skirtingBoardTexture);
    this.skirtingBoard.push(skirtingBoard3);

    this.skirtingBoard.forEach((e) => {
      this.addMesh(e.mesh);
    });
    // this.skirtingBoardObjs = [skirtingBoard1, skirtingBoard2, skirtingBoard3];
    this.skirtingBoardObjs = [skirtingBoard1, skirtingBoard2, skirtingBoard3, ...highFrameSkirtingBoard];
  }

  /**
   * @description: 摆放底柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  putBottomCupboard() {
    const sealPlateData = this.getLengthSealPlate('bottom');
    let datumPoint = null;
    let sealPlateMesh = null;

    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const sidePlateDepth = this.getSidePlateDepth('length1');
    const sealPlateLengthXPos = this.bottomLength1.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);
    // 移动柜子到指定位置
    this?.templateJson?.bottom?.length1?.frames.forEach((element, index) => {
      // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
      if (index > 0) {
        const preEl = this?.templateJson?.bottom?.length1?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));

        // 摆放补板后柜体处理
        if (sealPlateMesh && sealPlateLengthXPos && index === sealPlateLengthXPos) {
          datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
        } else {
          datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
        }
        const { rotation } = meshManage.moveModelToPosition(
          datumPoint,
          { x: -1, y: 1, z: 0 },
        );
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        meshManage.setModelPosition(
          {
            x: -meshManage.getModelSize().x * 0.5 - sidePlateDepth,
            y: SKIRTINGBOARDCONFIG.HEIGHT,
            z: meshManage.getModelSize().z * 0.5,
          },
        );
      }
      if (element.ventilator) {
        this.renderVentilator(element, { x: 0, y: 0, z: 0 });
      }
      // 补板处理 需要在摆完柜子之后进行
      if (sealPlateLengthXPos && index === sealPlateLengthXPos - 1) {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        // 渲染补板
        sealPlateMesh = this.bottomLength1.renderSealPlate(
          sealPlateData.length1, meshManage, BASICTYPE_ENUM.bottom, element,
          this,
        );
        // 获取模型最右边坐标数据
        datumPoint = sealPlateMesh?.getDatumPoint({ x: -1, y: 1, z: 0 });
      }
    });
  }

  /**
   * @description: 摆放顶柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  putTopCupboard() {
    const sealPlateData = this.getLengthSealPlate(BASICTYPE_ENUM.top);
    let datumPoint = null;
    let sealPlateMesh = null;
    const sealPlatePos = this.topLength1.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.top);

    // version 2.3 add by xiaohua.zhu 20220330 侧板对象结构有调整 需要判断版本
    const sidePlateDepth = this.getSidePlateDepth('length1', 'top');
    if (!this.topLength1) {
      this.topLength1 = new LengthX(this.templateJson, this.scene, 'top', 'length1');
    }
    // 二字型特殊处理 顶部只有高柜情况
    const checkLengthXPosTopNoFrames = LengthX.checkTopNoFrames(this.templateJson, BASICTYPE_ENUM.top);
    if (checkLengthXPosTopNoFrames) {
      sealPlateMesh = renderNoFrame.renderSealPlate(
        sealPlateData.length1,
        BASICTYPE_ENUM.top,
        BASICLENGTHTYPE_ENUM.length1,
        this,
      );
    }

    // 移动柜子到指定位置
    this?.templateJson?.top?.length1?.frames.forEach((element, index) => {
      // 一期空高柜判断
      if (HightFrame.checkEmptyPlaceholderHighFrame(element)) {
        return;
      }
      // 高柜占位作用
      if (checkPreFrameIsHighFrame(this?.templateJson?.top?.length1?.frames, index)) {
        const preEl = this?.templateJson?.top?.length1?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        const point = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
        point.y = TOPFRAME_GROUND(this.templateJson) - meshManage.getModelSize().y;
        const { rotation } = meshManage.moveModelToPosition(
          point,
          { x: -1, y: 1, z: 0 },
        );
        this.rotationMeshes[element.componentBasic.id] = rotation;

        // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
      } else if (index > 0) {
        const preEl = this?.templateJson?.top?.length1?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));

        // 摆放补板后柜体处理
        if (sealPlateMesh && sealPlatePos && index === sealPlatePos) {
          datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
        } else {
          datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
        }

        const { rotation } = meshManage.moveModelToPosition(
          datumPoint,
          { x: -1, y: 1, z: 0 },
        );
        this.rotationMeshes[element.componentBasic.id] = rotation;
        // 高柜在顶柜上 移动 y
        if (checkFrameIsHighFrame(element)) {
          meshManage.mesh.position.y = SKIRTINGBOARDCONFIG.HEIGHT;
        }
      } else {
        // 第一个位置为转角柜
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        const moveX = sealPlateMesh ? -sealPlateMesh.getModelSize().x : 0;
        meshManage.setModelPosition(
          {
            x: -meshManage.getModelSize().x * 0.5 - sidePlateDepth + moveX,
            y: TOPFRAME_GROUND(this.templateJson) - meshManage.getModelSize().y,
            z: meshManage.getModelSize().z * 0.5,
          },
        );
      }
      // 补板处理
      if (sealPlatePos && index === sealPlatePos - 1 && !checkLengthXPosTopNoFrames) {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        // 渲染补板
        sealPlateMesh = new LengthX(this.templateJson, this.scene).renderSealPlate(
          sealPlateData.length1, meshManage, BASICTYPE_ENUM.top, element,
          this,
        );
      }
    });
  }

  /**
   * @description: 获取相机最佳位置的参数
   * @param {*}
   * @return {*} {target:Vector3,position:Vector3}
   * @author: Yongchao Wang
   */
  getCameraBestConfig(fov, allMeshes, camera) {
    const max = { x: 0, y: TOPFRAME_GROUND(this.templateJson), z: MINIMU_CAMERA_DISTANCE };
    const min = {
      x: -this.bottomLength1.getSideLength(),
      y: 0,
      z: 0,
    };
    const size = { x: max.x - min.x, y: max.y - min.y, z: max.z - min.z };

    const position = {};
    position.x = -size.x / 2;
    position.y = size.y / 2;
    const target = new Vector3(
      position.x,
      size.y / 2,
      0,
    );
    position.z = target.y / Math.tan(fov / 2);
    // eslint-disable-next-line no-underscore-dangle
    const ratio = this.scene._engine.getAspectRatio(camera);
    const z = size.x / 2 / Math.tan((fov * ratio) / 2);
    position.z = Math.max(z, position.z) + size.z;
    return {
      target,
      position: new Vector3(position.x, position.y, position.z),
      lowerAlphaLimit: 0,
      upperAlphaLimit: Math.PI,
      alpha: Math.PI / 2,
      beta: 1.4492930597593832,
    };
  }
}

export default RenderIType;
